"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stonehenge = void 0;
const entity_1 = require("@jobilla/entity");
const rxjs_1 = require("rxjs");
const LogEvent_entity_1 = require("./interfaces/LogEvent.entity");
class Stonehenge {
    constructor() {
        this.events = {
            onBeforeLog: new rxjs_1.Subject(),
            onAfterLog: new rxjs_1.Subject(),
            onPauseLog: new rxjs_1.Subject(),
            onUnPauseLog: new rxjs_1.Subject()
        };
    }
    static get instance() {
        if (!Stonehenge.self) {
            Stonehenge.self = new Stonehenge();
        }
        return Stonehenge.self;
    }
    static destroyInstance() {
        delete Stonehenge.self;
    }
    start(configuration) {
        if (!Stonehenge.self) {
            throw new Error('No Stonehenge instance set');
        }
        Stonehenge.self.configuration = configuration;
        Stonehenge.self.paused = false;
        console.info('[Jobilla] Loaded!');
    }
    /**
     * Temporarily pause analytics ingestion
     *
     * @description WARNING: THIS WILL DISABLE ANY ANALYTIC REQUEST
     */
    pause() {
        this.events.onPauseLog.next(true);
        Stonehenge.self.paused = true;
    }
    /**
     * Unpause analytics ingestion to
     * enable ingestion after pausing
     */
    unpause() {
        this.events.onUnPauseLog.next(true);
        Stonehenge.self.paused = false;
    }
    on(event, action) {
        this.events[event].subscribe((v) => action(v));
    }
    /**
     * This can be used if you cant pass your context on start.
     * If persist is true it will continue to use context
     * provided by this method. Otherwise it will return
     * to the original context provided in start().
     */
    setContext(context, options = { persist: false }) {
        const originalContext = Stonehenge.self.configuration.context;
        Stonehenge.self.configuration.context = { ...originalContext, ...context };
        if (!options.persist) {
            this.on('onAfterLog', () => {
                Stonehenge.self.configuration.context = originalContext;
            });
        }
    }
    /**
     * Log an event to Stonehenge
     * @param {string} message
     * @param {string} [metadata] - string or stringified JSON object
     */
    log(message, metadata) {
        this.events.onBeforeLog.next(true);
        const logContext = Stonehenge.self.configuration.context;
        Stonehenge.logEvent = entity_1.EntityBuilder.buildOne(LogEvent_entity_1.StonehengeLogEvent, {
            event_id: logContext?.eventIdPrefix != null
                ? `${logContext.eventIdPrefix}.${message}`
                : message,
            metadata: metadata ?? null,
            ...Stonehenge.self.configuration,
            ...Stonehenge.self.configuration.context
        });
        if (!Stonehenge.self.paused) {
            void this.sendAnalyticsEvent();
        }
        this.events.onAfterLog.next(true);
        return false;
    }
    sendAnalyticsEvent() {
        const analyticsEndpointUrl = `${this.configuration.serverApiRoot}/analytics/events`;
        const analyticsPayload = JSON.stringify(Stonehenge.logEvent.toJson());
        try {
            const beacon = navigator.sendBeacon.bind(navigator);
            return beacon(analyticsEndpointUrl, new Blob([analyticsPayload], { type: 'application/json' }));
        }
        catch (error) {
            return fetch(analyticsEndpointUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: analyticsPayload
            }).catch((e) => console.error(e));
        }
    }
}
exports.Stonehenge = Stonehenge;
//# sourceMappingURL=index.js.map